import { Typography, Box, Button } from '@mui/material';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'src/hooks/useAuth';

const NotFound = () => {
    const navigate = useNavigate();
    const auth = useAuth();
    if (!auth) {
        return window.location.href = "/";
    }

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                alignItems: 'center',
                height: window.innerHeight,
                flexDirection: 'column',
                gap: '20px'
            }}>
            <Typography sx={{
                fontSize: '190px',
                fontWeight: 600,
                lineHeight: '9.7rem'
            }}>
                404
            </Typography>

            <Typography sx={{
                fontSize: '32px',
                fontWeight: 500
            }}>
                Page not found!
            </Typography>

            <Button
                variant='contained'
                sx={{
                    boxShadow: 'none'
                }}
                onClick={() => navigate("/")}
            >
                Back to home
            </Button>
        </Box>
    )
}

export default NotFound;